import React from "react";
import NumberFormat from "react-number-format";

function CashMaskedInput({ onChange, value, customInput, ...props }) {
  return (
    <NumberFormat
      thousandSeparator={"."}
      isNumericString
      prefix="R$ "
      decimalScale={2}
      decimalSeparator={","}
      fixedDecimalScale={true}
      customInput={customInput}
      margin="dense"
      variant="outlined"
      onValueChange={(values) => {
        onChange({
          target: {
            values,
          },
        });
      }}
      value={value}
      {...props}
    />
  );
}

export default CashMaskedInput;